/**
 * Delivery Estimate Widget
 * Premium compact delivery promise for Shopify product pages.
 */
(function () {
  "use strict";

  var STORAGE_KEY = "de_location";
  var STORAGE_TTL = 24 * 60 * 60 * 1000;

  function esc(str) {
    if (str === null || str === undefined) return "";
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function attr(el, name, fallback) {
    var value = el.getAttribute(name);
    return value === null || value === "" ? fallback : value;
  }

  function boolAttr(el, name, fallback) {
    var value = el.getAttribute(name);
    if (value === null || value === "") return fallback;
    return value !== "false";
  }

  var ICONS = {
    lightning_truck:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 64" fill="none" class="de-icon" aria-hidden="true">' +
      '<path d="M4 18H24" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>' +
      '<path d="M4 32H30" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>' +
      '<path d="M4 46H22" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>' +
      '<rect x="28" y="14" width="38" height="28" rx="5" stroke="currentColor" stroke-width="5"/>' +
      '<path d="M66 24H78L90 36V42H66V24Z" stroke="currentColor" stroke-width="5" stroke-linejoin="round"/>' +
      '<path d="M77 25L83 36" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>' +
      '<circle cx="40" cy="48" r="6" stroke="currentColor" stroke-width="5"/>' +
      '<circle cx="80" cy="48" r="6" stroke="currentColor" stroke-width="5"/>' +
      '<path d="M50 17L38 32H48L41 41L60 25H50L55 17H50Z" fill="currentColor"/>' +
      "</svg>",
    truck:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="de-icon" aria-hidden="true">' +
      '<rect x="1" y="3" width="15" height="13" rx="2"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
    package:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="de-icon" aria-hidden="true">' +
      '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>',
    clock:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="de-icon" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
    location_pin:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="de-icon" aria-hidden="true"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>'
  };

  function getIcon(iconStyle) {
    if (iconStyle === "none") return "";
    return ICONS[iconStyle || "lightning_truck"] || ICONS.lightning_truck;
  }

  function loadSavedLocation() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || Date.now() - (data.savedAt || 0) > STORAGE_TTL) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (_) { return null; }
  }

  function saveLocation(country, postalCode) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ country: country || "", postalCode: postalCode || "", savedAt: Date.now() }));
    } catch (_) {}
  }

  function clearSavedLocation() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
  }

  function formatCountdown(diffMs) {
    var totalSecs = Math.max(0, Math.floor(diffMs / 1000));
    var h = Math.floor(totalSecs / 3600);
    var m = Math.floor((totalSecs % 3600) / 60);
    var s = totalSecs % 60;
    function pad(n) { return n < 10 ? "0" + n : String(n); }
    var parts = [];
    if (h > 0) parts.push(h + "h");
    parts.push(pad(m) + "m");
    parts.push(pad(s) + "s");
    return parts.join(" ");
  }

  function startCountdown(wrapper, cutoffTimestamp, prefix) {
    var timerEl = wrapper.querySelector(".de-countdown");
    if (!timerEl || !cutoffTimestamp) return;
    var cutoff = new Date(cutoffTimestamp).getTime();
    if (!cutoff || cutoff <= Date.now()) {
      timerEl.hidden = true;
      var sep = timerEl.nextElementSibling;
      if (sep && sep.classList.contains("de-sep")) sep.hidden = true;
      return;
    }
    function tick() {
      var diff = cutoff - Date.now();
      if (diff <= 0) {
        timerEl.hidden = true;
        var sib = timerEl.nextElementSibling;
        if (sib && sib.classList.contains("de-sep")) sib.hidden = true;
        clearInterval(interval);
        return;
      }
      timerEl.innerHTML = '<span class="de-countdown__prefix">' + esc(prefix || "Order within") + '</span> <strong class="de-countdown__time">' + esc(formatCountdown(diff)) + '</strong>';
    }
    tick();
    var interval = setInterval(tick, 1000);
    var observer = new MutationObserver(function () {
      if (!document.contains(wrapper)) {
        clearInterval(interval);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function parseVariantAvailabilityMap(container) {
    var raw = attr(container, "data-variant-availability-map", "{}");
    try {
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (_) {
      return {};
    }
  }

  function selectedVariantIsAvailable(container) {
    var variantId = attr(container, "data-variant-id", "");
    var availabilityMap = parseVariantAvailabilityMap(container);
    if (variantId && Object.prototype.hasOwnProperty.call(availabilityMap, variantId)) {
      return availabilityMap[variantId] !== false;
    }
    return boolAttr(container, "data-variant-available", true);
  }

  function updateVariantAvailability(container, variant) {
    if (!variant) return;
    if (variant.id !== undefined && variant.id !== null) {
      container.setAttribute("data-variant-id", String(variant.id));
    }
    if (variant.available !== undefined) {
      container.setAttribute("data-variant-available", variant.available ? "true" : "false");
      var variantId = attr(container, "data-variant-id", "");
      if (variantId) {
        var availabilityMap = parseVariantAvailabilityMap(container);
        availabilityMap[variantId] = !!variant.available;
        try {
          container.setAttribute("data-variant-availability-map", JSON.stringify(availabilityMap));
        } catch (_) {}
      }
    }
  }

  function findPurchaseScope(container) {
    return container.closest(".pdp-content, .product, .product-main, section, main") || document;
  }

  function purchaseButtonLooksUnavailable(container) {
    var scope = findPurchaseScope(container);
    var selectors = [
      'form[action*="/cart/add"] button[type="submit"]',
      'form[action*="/cart/add"] button[name="add"]',
      'button[name="add"]',
      '.product-form__submit',
      '[data-add-to-cart]',
      'button[type="submit"]'
    ];
    var buttons = scope.querySelectorAll(selectors.join(","));
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var text = (button.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
      var disabled = button.disabled || button.getAttribute("aria-disabled") === "true" || button.classList.contains("disabled");
      if (disabled && /sold\s*out|out\s*of\s*stock|unavailable/.test(text)) return true;
    }
    return false;
  }

  function widgetShouldHideForPurchasingState(container) {
    return !selectedVariantIsAvailable(container) || purchaseButtonLooksUnavailable(container);
  }

  function observePurchaseState(container) {
    if (container.__dePurchaseObserver) return;
    var scope = findPurchaseScope(container);
    var buttons = scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] button[name="add"], button[name="add"], .product-form__submit, [data-add-to-cart]');
    if (!buttons.length) return;

    var timeout = null;
    function refetchSoon() {
      clearTimeout(timeout);
      timeout = setTimeout(function () { fetchEstimate(container, undefined); }, 150);
    }

    var observer = new MutationObserver(refetchSoon);
    for (var i = 0; i < buttons.length; i++) {
      observer.observe(buttons[i], { attributes: true, childList: true, subtree: true, attributeFilter: ["disabled", "aria-disabled", "class"] });
    }
    container.__dePurchaseObserver = observer;
  }

  function buildLocationInput(container, opts, onSubmit) {
    var form = document.createElement("form");
    form.className = "de-location-form";
    form.setAttribute("autocomplete", "off");
    var zipInput = document.createElement("input");
    zipInput.type = "text";
    zipInput.className = "de-location-input";
    zipInput.placeholder = "ZIP / postal code";
    zipInput.maxLength = 10;
    zipInput.setAttribute("aria-label", "ZIP or postal code");
    var submitBtn = document.createElement("button");
    submitBtn.type = "submit";
    submitBtn.className = "de-location-btn";
    submitBtn.textContent = "Apply";
    var cancelBtn = document.createElement("button");
    cancelBtn.type = "button";
    cancelBtn.className = "de-location-cancel";
    cancelBtn.textContent = "Cancel";
    form.appendChild(zipInput);
    form.appendChild(submitBtn);
    form.appendChild(cancelBtn);
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var zip = zipInput.value.trim();
      if (!zip) return;
      onSubmit(null, zip);
    });
    cancelBtn.addEventListener("click", function () {
      form.remove();
      var subline = container.querySelector(".de-widget__subline");
      if (subline) subline.style.display = "";
    });
    var saved = loadSavedLocation();
    if (saved && saved.postalCode) {
      var clearLink = document.createElement("button");
      clearLink.type = "button";
      clearLink.className = "de-location-clear";
      clearLink.textContent = "Clear saved location";
      clearLink.addEventListener("click", function () {
        clearSavedLocation();
        form.remove();
        onSubmit(null, null);
      });
      form.appendChild(clearLink);
    }
    return form;
  }

  function applyClasses(container, opts) {
    container.classList.remove("de-layout-compact-card", "de-layout-compact-row", "de-mobile-stack", "de-compact", "de-theme-dark", "de-theme-auto");
    container.classList.add(opts.layoutStyle === "compact_row" ? "de-layout-compact-row" : "de-layout-compact-card");
    if (opts.mobileStack) container.classList.add("de-mobile-stack");
    if (opts.compact) container.classList.add("de-compact");
    if (opts.theme === "auto") container.classList.add("de-theme-auto");
    if (opts.theme === "dark") container.classList.add("de-theme-dark");
  }

  function stripKnownPrefix(text, prefix) {
    if (!text || !prefix) return text || "";
    if (text.toLowerCase().indexOf(prefix.toLowerCase()) === 0) return text.slice(prefix.length).trim();
    return text;
  }

  function deriveHeadline(display, opts) {
    var d = display || {};
    var headline = d.headline || "";
    var dateText = d.headlineDateText || d.headlineDates || d.dateText || d.arrivalDateText || "";
    var prefix = (opts.headlinePrefix && opts.headlinePrefix.trim()) || d.headlinePrefix || d.prefix || "";
    if (!prefix && headline) {
      var byMatch = headline.match(/^(.*?\bby)\s+(.+)$/i);
      if (byMatch) {
        prefix = byMatch[1];
        if (!dateText) dateText = byMatch[2];
      }
    }
    if (!dateText && headline && prefix) dateText = stripKnownPrefix(headline, prefix);
    if (!prefix && !dateText) return { prefix: headline, date: "" };
    if (!prefix) prefix = headline && dateText ? headline.replace(dateText, "").trim() : "";
    return { prefix: prefix, date: dateText };
  }

  function deriveLocation(data, opts) {
    var d = (data && data.display) || {};
    var loc = (data && data.location) || {};
    var prefix = (opts.locationPrefix && opts.locationPrefix.trim()) || d.locationPrefix || "Deliver to";
    var text = d.locationText || "";

    if (!text && d.locationLine) {
      text = stripKnownPrefix(d.locationLine, prefix).replace(/^Deliver to\s+/i, "").trim();
    }

    if (!text) {
      var city = loc.city || "";
      var region = loc.region || loc.province || loc.state || "";
      var postalCode = loc.postalCode || loc.zip || "";
      var country = loc.country || "";
      var parts = [];

      if (city) parts.push(city);
      if (region) parts.push(region);

      if (parts.length) {
        text = parts.join(", ");
      } else if (postalCode && region) {
        text = postalCode + ", " + region;
      } else if (postalCode) {
        text = postalCode;
      } else if (country) {
        text = country;
      }
    }

    return { prefix: prefix, text: text };
  }

  function renderSuccess(container, data, opts) {
    var d = data.display || {};
    var showCountdown = opts.showCountdown && !!data.cutoffTimestamp;
    var showSeparators = opts.showSeparators;
    var showLocation = opts.showLocation;
    var showChange = opts.showChange;
    var headline = deriveHeadline(d, opts);
    var location = deriveLocation(data, opts);
    var hasLocation = showLocation && !!location.text;
    var sep = showSeparators ? '<span class="de-sep" aria-hidden="true">·</span>' : '<span class="de-sep de-sep--hidden" aria-hidden="true"></span>';

    var html = '<div class="de-widget" role="status" aria-live="polite">';
    if (opts.showIcon && opts.iconStyle !== "none") html += '<div class="de-widget__icon">' + getIcon(opts.iconStyle) + '</div>';
    html += '<div class="de-widget__content">';
    html += '<div class="de-widget__headline">';
    if (headline.prefix) html += '<span class="de-widget__headline-prefix">' + esc(headline.prefix) + '</span>';
    if (headline.date) html += '<span class="de-widget__headline-date">' + esc(headline.date) + '</span>';
    html += '</div>';

    if (showCountdown || hasLocation || showChange) {
      html += '<div class="de-widget__subline">';
      if (showCountdown) html += '<span class="de-countdown"></span>';
      var groupParts = [];
      if (hasLocation) groupParts.push('<span class="de-location"><span class="de-location__prefix">' + esc(location.prefix) + '</span> <span class="de-location__text">' + esc(location.text) + '</span></span>');
      if (showChange) groupParts.push('<button type="button" class="de-change-link">' + esc(opts.changeLabel || "Change") + '</button>');
      if (showCountdown && groupParts.length) html += sep;
      if (groupParts.length) {
        html += '<span class="de-subline__group">';
        for (var i = 0; i < groupParts.length; i++) {
          if (i > 0) html += sep;
          html += groupParts[i];
        }
        html += '</span>';
      }
      html += '</div>';
    }
    html += '</div></div>';
    container.innerHTML = html;

    if (showCountdown) startCountdown(container, data.cutoffTimestamp, opts.countdownPrefix || d.countdownPrefix || "Order within");

    if (showChange) {
      var changeBtn = container.querySelector(".de-change-link");
      if (changeBtn) {
        changeBtn.addEventListener("click", function () {
          var subline = container.querySelector(".de-widget__subline");
          if (subline) subline.style.display = "none";
          var form = buildLocationInput(container, opts, function (country, postalCode) {
            form.remove();
            if (postalCode !== null) {
              var manualCountry = country || opts.shopifyCountry || "";
              saveLocation(manualCountry, postalCode);
              fetchEstimate(container, { country: manualCountry, postalCode: postalCode });
            } else {
              fetchEstimate(container, {});
            }
          });
          var content = container.querySelector(".de-widget__content");
          if (content) content.appendChild(form); else container.appendChild(form);
          var inp = form.querySelector("input");
          if (inp) inp.focus();
        });
      }
    }
  }

  function renderLoading(container) {
    container.innerHTML = '<div class="de-widget de-widget--loading" aria-hidden="true"><div class="de-skeleton de-skeleton--icon"></div><div class="de-skeleton__content"><div class="de-skeleton de-skeleton--line de-skeleton--wide"></div><div class="de-skeleton de-skeleton--line"></div></div></div>';
  }

  function renderError(container, opts) {
    if (opts.hideUnavailable) { container.innerHTML = ""; return; }
    container.innerHTML = '<div class="de-widget de-widget--unavailable">' + (opts.showIcon && opts.iconStyle !== "none" ? '<div class="de-widget__icon">' + getIcon(opts.iconStyle) + '</div>' : '') + '<div class="de-widget__content"><div class="de-widget__unavailable-text">' + esc(opts.unavailableText || "Delivery estimate unavailable") + '</div></div></div>';
  }

  function getOptions(container) {
    return {
      theme: attr(container, "data-theme", "dark"),
      layoutStyle: attr(container, "data-layout-style", "compact_card"),
      compact: boolAttr(container, "data-compact", false),
      mobileStack: boolAttr(container, "data-mobile-stack", true),
      showIcon: boolAttr(container, "data-show-icon", true),
      showLocation: boolAttr(container, "data-show-location", true),
      showChange: boolAttr(container, "data-show-change", true),
      showCountdown: boolAttr(container, "data-show-countdown", true),
      showSeparators: boolAttr(container, "data-show-separators", true),
      hideUnavailable: boolAttr(container, "data-hide-unavailable-state", true),
      iconStyle: attr(container, "data-icon-style", "lightning_truck"),
      headlinePrefix: attr(container, "data-headline-prefix", ""),
      countdownPrefix: attr(container, "data-countdown-prefix", ""),
      locationPrefix: attr(container, "data-location-prefix", ""),
      changeLabel: attr(container, "data-change-label", "Change"),
      unavailableText: attr(container, "data-unavailable-text", "Delivery estimate unavailable"),
      shopifyCountry: attr(container, "data-country", "")
    };
  }

  function fetchEstimate(container, locationOverride) {
    var apiUrl = attr(container, "data-api-url", "");
    var shopDomain = attr(container, "data-shop-domain", "");
    var productHandle = attr(container, "data-product-handle", "");
    var tagsRaw = attr(container, "data-product-tags", "[]");
    var variantId = attr(container, "data-variant-id", "");
    var opts = getOptions(container);
    applyClasses(container, opts);

    if (widgetShouldHideForPurchasingState(container)) {
      container.innerHTML = "";
      return;
    }

    var productTags;
    try { productTags = JSON.parse(tagsRaw); } catch (_) { productTags = []; }
    if (!apiUrl || !shopDomain || !productHandle) { container.innerHTML = ""; return; }

    renderLoading(container);

    var manualCountry = null;
    var postalCode = null;
    if (locationOverride && locationOverride.postalCode) {
      postalCode = locationOverride.postalCode;
      manualCountry = locationOverride.country || opts.shopifyCountry || null;
    } else if (!locationOverride) {
      var saved = loadSavedLocation();
      if (saved && saved.postalCode) {
        manualCountry = saved.country || opts.shopifyCountry || null;
        postalCode = saved.postalCode || null;
      }
    }

    var payload = { shopDomain: shopDomain, productHandle: productHandle, productTags: productTags, variantId: variantId || null };
    if (opts.shopifyCountry) payload.shopifyCountry = opts.shopifyCountry;
    if (manualCountry) payload.country = manualCountry;
    if (postalCode) payload.postalCode = postalCode;

    fetch(apiUrl.replace(/\/$/, "") + "/api/delivery/estimate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    })
      .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function (data) {
        if (!data.visible) { container.innerHTML = ""; return; }
        if (data.display) renderSuccess(container, data, opts);
        else renderError(container, opts);
      })
      .catch(function () { renderError(container, opts); });
  }

  function initContainer(container) {
    observePurchaseState(container);
    fetchEstimate(container, undefined);
  }

  function initAll() {
    var containers = document.querySelectorAll("[data-delivery-estimate]");
    for (var i = 0; i < containers.length; i++) initContainer(containers[i]);
  }

  document.addEventListener("variant:changed", function (e) {
    var containers = document.querySelectorAll("[data-delivery-estimate]");
    for (var i = 0; i < containers.length; i++) {
      var c = containers[i];
      if (e.detail && e.detail.variant) updateVariantAvailability(c, e.detail.variant);
      fetchEstimate(c, undefined);
    }
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
})();
